import { ModalSolicitacaoExistenteController } from '../modal/modal-solicitacao-existente/modal-solicitacao-existente.component';

function localeTitleCase(value) {
  if (!value) {
    return value;
  }

  return value.replace(/(\s*?)(\S)(\S+)(\s*?)/g, function (match, p1, p2, p3, p4) {
    return [p1, p2.toLocaleUpperCase(), p3.toLocaleLowerCase(), p4].join('');
  });
}

export function AtendimentoNovaSolicitacaoComponent($state, $timeout, $uibModal, AtendimentoResource, Cliente, Perfil) {
  'ngInject';
  var $ctrl = this;
  $ctrl.contatos = [];
  $ctrl.formularios = [
    {
      display: 'Encomendas',
      value: 'encomendas',
      assuntos: [
        'Rastreamento de encomenda',
        'Endereço não localizado',
        'Destinatário ausente',
        'Atraso na entrega',
        'Devolução de encomenda',
        'Comprovante de recebimento',
        'Acareação do processo de entrega',
        'Impedimentos na entrega',
        'Cancelamento de entrega',
        'Encomenda extraviada',
        'Local não atendido',
        'Encomenda avariada',
        'Pedido trocado',
        'Avaria/furto no recebimento',
        'Roubo ou furto',
        'Logística reversa',
        'Envio de romaneio - Encomenda sem movimentação',
        'Outros'
      ]
    },
    {
      display: 'Financeiro',
      value: 'financeiro',
      assuntos: [
        'Problema fiscal',
        'Revisão de valor',
        'Reemissão da Nota Fiscal',
        'Nota Fiscal',
        'Pagamentos',
        'Dúvidas de cobrança',
        'Desbloqueio de conta'
      ]
    },
    {
      display: 'Coleta',
      value: 'coleta',
      assuntos: [
        'Cancelamento de coleta',
        'Agendamento de coleta',
        'Coleta não realizada'
      ]
    },
    {
      display: 'Minha conta',
      value: 'minha_conta',
      assuntos: [
        'Dados cadastrais',
        'Cancelamento de conta',
        'Outros'
      ]
    }
  ];

  $ctrl.$onInit = function() {
    $ctrl.user = Perfil.getCacheUserData();
    $ctrl.data = {};

    Cliente.getContatos($ctrl.user.id).then(function(data){
      $ctrl.contatos = data.reduce(function (obj, cur) {
        if (!cur.perfil) {
          cur.perfil = 'GERAL';
        }
        cur.perfil = localeTitleCase(cur.perfil);

        var categoria = obj.find(function (cat) {
          return cat.perfil === cur.perfil;
        });

        if (!categoria) {
          categoria = {
            perfil: cur.perfil,
            contatos: []
          };

          obj.push(categoria);
        }

        categoria.contatos.push(cur);

        return obj;
      }, []);

      $ctrl.contatos.forEach(function (categoria) {
        categoria.sort(function (a, b) { return a.email.localeCompare(b.email) })
      });
    });
  }

  $ctrl.respostaSucesso = function (ticket) {
    var eventParams = {
      ticketId: ticket.id,
      email: ticket.requester.email,
      subject: ticket.subject
    };

    $state.go('relacionamento', {newTicket: true});
  }

  $ctrl.prepareTicketData = function () {
    var data = {
      subject: $ctrl.data.assunto === 'Outros' ? $ctrl.data.subject : $ctrl.data.assunto,
      trackingCode: $ctrl.data.formulario.value === 'encomendas' ? $ctrl.data.codigoRastreamento : undefined,
      contactEmail: $ctrl.data.contato.email
    };

    if (!data.subject || data.subject.trim().length === 0) {
      return false;
    }

    if ($ctrl.data.formulario.value === 'encomendas') {
      if (!data.trackingCode) {
        return false;
      }

      return $ctrl.validateTrackingCode(data.trackingCode).then(function (valid) {
        return valid ? data : false;
      });
    }

    return data;
  }

  $ctrl.validateTrackingCode = function (trackingCode) {
    if (!trackingCode || /^\s*$/.test(trackingCode)) {
      return;
    }

    $ctrl.validatingTrackingCode = true;
    return AtendimentoResource.query({
      status: 'open',
      trackingCode: trackingCode
    }).$promise.then(function (tickets) {
      $ctrl.validatingTrackingCode = false;
      var valid = tickets.total === 0;

      if (!valid) {
        $timeout(function () {
          $uibModal.open({
            animation: false,
            windowClass: 'modal-nova-solicitacao',
            template: require('../modal/modal-solicitacao-existente/modal-solicitacao-existente.component.html'),
            controller: ModalSolicitacaoExistenteController,
            resolve: {
              ticketData: () => tickets.tickets[0],
            }
          });
        }, 0);
      }

      return valid;
    }).then(function (valid) {
      $ctrl.trackingCodeValid = valid;
      return valid;
    });
  }
}
